import { TransactionStatus } from '../store/types';

import { IMultisigTransaction } from './transform-multisig-transaction';

// TODO_R: move into NonceInput/utils.ts
export const nextAvailableNonce = (
  transactions: IMultisigTransaction[],
  nextPossibleNonce: number
) => {
  if (transactions.length === 0) return nextPossibleNonce;
  let nonces: number[] = [];
  if (transactions.some((tx) => tx.nonce === nextPossibleNonce)) {
    nonces = [...transactions.map((t) => t.nonce)].sort((a, b) => a - b);
  } else {
    return nextPossibleNonce;
  }
  const uniqueNonces = Array.from(new Set(nonces)).filter((nonce) => nonce >= nextPossibleNonce);

  let recommendedNonce = null;
  for (let i = 0; i < uniqueNonces.length - 1; i++) {
    if (uniqueNonces[i] + 1 !== uniqueNonces[i + 1]) {
      recommendedNonce = uniqueNonces[i] + 1;
      break;
    }
  }

  return recommendedNonce || uniqueNonces[uniqueNonces.length - 1] + 1;
};

// TODO_R: move into QueueTransactionsTab/util.ts
export const findNonceToExecuteAfterFirst = (
  transactions: IMultisigTransaction[],
  nonceToExecuteFirst: number
) => {
  const queuedNonces = transactions
    .filter(
      (tx) => tx.status === TransactionStatus.QUEUED || tx.status === TransactionStatus.EXECUTION
    )
    .map((tx) => tx.nonce);
  const nonces = [nonceToExecuteFirst, ...queuedNonces].sort((a, b) => a - b);
  const uniqueNonces = Array.from(new Set(nonces));
  const nonceToExecuteFirstIndex = uniqueNonces.findIndex(
    (uniqueNonce) => uniqueNonce === nonceToExecuteFirst
  );

  return uniqueNonces[nonceToExecuteFirstIndex + 1] || null;
};
